import { render, staticRenderFns } from "./TrainingMaterialModal.vue?vue&type=template&id=690142da"
import script from "../../../scripts/partials/TrainingMaterialModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/TrainingMaterialModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports